<template>
  <div style="word-break: break-word" class="tw-flex tw-space-x-5"
    :class="`${(isSentByUser ? 'tw-flex-row-reverse tw-space-x-reverse':'tw-flex-row tw-justify-start')}`"
  >
    <a href="#">
      <img :src="data.sender.mid_avatar" alt="" class="tw-w-10 tw-h-10 tw-rounded-full">
    </a>
    <div class="tw-max-w-2/3 tw-flex tw-flex-col tw-space-y-3" :class="`${isSentByUser ? 'tw-items-end' : 'tw-items-start'}`">
      <div class="tw-rounded tw-p-3 tw-bg-opacity-10" :class="`${isSentByUser ? 'tw-bg-green' : 'tw-bg-blue'}`">{{data.content}}</div>
      <template v-if="data.attachments !== null && data.attachments.length !== 0" >
        <a :href="attachment" v-for="attachment in data.attachments" :class="`${isSentByUser ? 'tw-bg-green' : 'tw-bg-blue'}`"
          class="tw-flex tw-items-center tw-space-x-2 tw-bg-opacity-10 tw-rounded tw-p-3 cursor:tw-bg-opacity-15 cursor:tw-text-blue" >
          <i class="bx bxs-download tw-text-3xl"></i>
          <div class="tw-max-w-64 tw-truncate">{{attachment.replace(/^.*[\\\/]/, '')}}</div>
        </a>
      </template>
      <div class="tw-text-lg tw-text-gray-500">{{data.created_at}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      data: {},
      user: {},
    },
    computed: {
      isSentByUser() {
        return this.user.id === this.data.sender.id
      }
    }
  }
</script>
